export default "__VITE_ASSET__c3ebe4e6__"